var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_SERVER_URL as STG2_API_URL } from 'src/environments/environment.stg2';
import { Subscription } from 'rxjs';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from './account.service';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "./http-header.service";
import * as i2 from "@angular/common/http";
import * as i3 from "ngx-toastr";
import * as i4 from "./account.service";
var SyncToStgService = /** @class */ (function () {
    function SyncToStgService(header, http, toastrService, accountService) {
        this.header = header;
        this.http = http;
        this.toastrService = toastrService;
        this.accountService = accountService;
        this.subscriptions = new Subscription();
    }
    SyncToStgService.prototype.ngOnDestroy = function () {
        this.subscriptions.unsubscribe();
    };
    SyncToStgService.prototype.requestGet_STG2 = function (requestDestination, params) {
        var url = STG2_API_URL + requestDestination;
        return this.http.get(url, this.header.getSTG2HttpOptions(params));
    };
    SyncToStgService.prototype.requestPost_STG2 = function (requestDestination, params) {
        var url = STG2_API_URL + requestDestination;
        return this.http.post(url, params, this.header.getSTG2HttpOptions());
    };
    SyncToStgService.prototype.signIn = function (loginForm) {
        var _this = this;
        var param = __assign({}, loginForm, { sync_to_stg2: true });
        if (this.needSync()) {
            var signInSub = this.requestPost_STG2('api/v1/auth/sign_in', param).subscribe(function (res) {
                // Headerの情報を取得、sessionにトークン設定
                _this.accountService.setSTG2Account(res);
                _this.toastrService.success('Syncログインに成功しました');
            }, function (error) {
                _this.toastrService.error('Syncログインに失敗しました');
            });
            this.subscriptions.add(signInSub);
        }
    };
    SyncToStgService.prototype.getCompanyList = function () {
        return this.requestGet_STG2('api/v1/company_list');
    };
    SyncToStgService.prototype.getCompany = function (id) {
        return this.requestGet_STG2('api/v1/company', { id: id });
    };
    SyncToStgService.prototype.createNewCompany = function (data) {
        return this.requestPost_STG2('api/v1/company', data);
    };
    SyncToStgService.prototype.checkSyncSignIn = function () {
        return localStorage.sync_to_stg2_account ? true : false;
    };
    SyncToStgService.prototype.needSync = function () {
        // STG2環境が利用可能な場合はtrueを返す
        return environment.production && !environment.staging;
    };
    SyncToStgService.ngInjectableDef = i0.defineInjectable({ factory: function SyncToStgService_Factory() { return new SyncToStgService(i0.inject(i1.HttpHeaderService), i0.inject(i2.HttpClient), i0.inject(i3.ToastrService), i0.inject(i4.AccountService)); }, token: SyncToStgService, providedIn: "root" });
    return SyncToStgService;
}());
export { SyncToStgService };
